import { useEffect, useState } from "react";
import axios from "axios";
import { FiDownload, FiTrash2, FiPlus } from "react-icons/fi";
import AddQrModal from "../components/AddQrModal";
import EditQrModal from "../components/EditQrModal";
import toast from 'react-hot-toast';

export default function DashboardPage() {
  const [entries, setEntries] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const token = localStorage.getItem("token");

  const fetchData = async () => {
    const res = await axios.get("/api/qr", {
      headers: { Authorization: `Bearer ${token}` },
    });
    setEntries(res.data);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/qr/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("QR Code deleted");
      fetchData();
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="flex justify-between items-center bg-white p-4 shadow">
        <h1 className="text-xl font-bold">My QR Codes</h1>
        <div className="space-x-2">
          <button
            onClick={() => setShowModal(true)}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 inline-flex items-center gap-2"
          >
            <FiPlus /> Add New
          </button>
          <button
            onClick={handleLogout}
            className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
          >
            Logout
          </button>
        </div>
      </header>

      <main className="p-6">
        <table className="w-full bg-white rounded shadow">
          <thead>
            <tr className="bg-gray-200 text-left">
            <th className="p-3">Name</th>
              <th className="p-3">URL</th>
              <th className="p-3">Preview</th>
              <th className="p-3">Views</th>
              <th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry._id} className="border-t">
                <td className="p-3 font-medium">{entry.name}</td>
                <td className="p-3 break-words">{entry.url}</td>
                <td className="p-3">
                  <img src={`/` + entry.qrCodePath} alt="QR" className="w-20 h-20" />
                </td>
                <td className="p-3">{entry.views || 0}</td>
                <td className="p-3 space-x-2">
                  <a
                    href={`/${entry.qrCodePath}`}
                    download
                    className="text-blue-600 hover:underline inline-flex items-center"
                  >
                    <FiDownload className="mr-1" /> Download
                  </a>
                  <button
                    onClick={() => handleDelete(entry._id)}
                    className="text-red-600 hover:underline inline-flex items-center"
                  >
                    <FiTrash2 className="mr-1" /> Delete
                  </button>
                  <button onClick={() => setEditingEntry(entry)} className="text-yellow-600 hover:underline ml-2">Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>

      {showModal && (
        <AddQrModal
          onClose={() => setShowModal(false)}
          onSuccess={fetchData}
        />
      )}

      {editingEntry && (
        <EditQrModal
          entry={editingEntry}
          onClose={() => setEditingEntry(null)}
          onSuccess={fetchData}
        />
      )}
    </div>
  );
}
